import { render, staticRenderFns } from "./PacketReceive.vue?vue&type=template&id=59969436&scoped=true"
import script from "./PacketReceive.vue?vue&type=script&lang=js"
export * from "./PacketReceive.vue?vue&type=script&lang=js"
import style0 from "./PacketReceive.vue?vue&type=style&index=0&id=59969436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59969436",
  null
  
)

export default component.exports